<template>
  <div class="flightDetailWeatherContainer" id="flightDetailWeatherContainer">
    <div class="weatherContainer">
      <div class="weatherIcon">
        <img :src="weatherIcon" />
      </div>
      <div class="weatherInfoContainer">
        <div class="temperatureContainer">
          <label class="weatherName">多云</label>
          <label class="temperature">6~17℃</label>
        </div>
        <div class="otherContainer">
          <label class="visibilityName">能见度:&nbsp;</label>
          <label class="visibility">8-10公里</label>
          <label class="cloudHeightName">云底高:&nbsp;</label>
          <label class="cloudHeight">600-800米</label>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="brightnessContainer">
      <label>地图暗度</label>
      <label class="brightnessValue">{{ brightness }}%</label>
      <img :src="lowBrightness" class="lowBrightness" />
      <div class="slider">
        <el-slider v-model="brightness" :show-tooltip="false"></el-slider>
      </div>
      <img :src="highBrightness" class="highBrightness" />
    </div>
  </div>
</template>

<script type="text/javascript">
import cloudy from "../../../assets/img/home/flightDetail/cloudy.png";
import lowBrightness from "../../../assets/img/home/flightDetail/lowBrightness.png";
import highBrightness from "../../../assets/img/home/flightDetail/highBrightness.png";

export default {
  name: "flightDetailWeather",
  data() {
    return {
      brightness: 85,
      weatherIcon: cloudy,
      lowBrightness: lowBrightness,
      highBrightness: highBrightness,
    };
  },
  methods: {},
  mounted() {},
  watch: {
    brightness(nval, oval) {
      this.$emit("setBgTransparency", nval);
    },
  },
  computed: {},
  components: {},
  beforeDestroy() {},
};
</script>

<style scoped>
@import "../../../assets/css/home/flightDetail/flightDetailWeather.css";
</style>

<style>
#flightDetailWeatherContainer .el-slider {
  width: 100%;
  height: 100%;
}

#flightDetailWeatherContainer .el-slider__runway {
  height: 7px;
  margin: 8px 0;
}

#flightDetailWeatherContainer .el-slider__bar {
  height: 7px;
  background: #ffa63e;
}

#flightDetailWeatherContainer .el-slider__button {
  border: 0px;
  background: url("../../../assets/img/home/flightDetail/selectSlider.png") -3px -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/flightDetail/flightDetailWeather.vue